import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Account',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Gestisci account',
      description: 'Mantieni il tuo account aggiornato e gestisci le impostazioni.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Metodi di pagamento',
      description: 'Aggiungi, modifica o seleziona il metodo di pagamento preferito.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Aiuto e FAQ',
    },
    [AccountItemEnum.Logout]: {
      title: 'Esci',
    },
    [AccountItemEnum.Language]: {
      title: 'Lingua',
    },
  },
};
